import styled from "styled-components";
import { COLORS, FONT_SIZE, SCROLLBAR_STYLES } from "../../constants/Styles";

export const CustomPartContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
`;

export const TableContainer = styled.div`
  overflow-x: scroll;
  width: 100%;
  ${SCROLLBAR_STYLES};
`;

export const EditButton = styled.div`
  cursor: pointer;
`;

export const WarningContainer = styled.div`
  font-size: ${FONT_SIZE.size13};
  color: ${COLORS.error};
  text-align: center;
  padding: 0 2rem;
  margin-top: 1rem;
`;
